export default __webpack_public_path__ + "static/media/user.330d8827.svg";